/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:block:configurations-pilet:configuration-display */

export interface ConfigurationDisplayBlockParams {
	/**
	 * Configuration RID
	 */
	rid?: string;
}
/** Block parameters for urn:block:configurations-pilet:configuration-provider */

export interface ConfigurationProviderBlockParams {
	/**
	 * A valid RID of the configuration
	 */
	config: string;
}
/** Zone parameters for urn:zone:configurations-pilet:configuration-provider:content */

export interface ConfigurationProviderContentZoneParams {}
/** Contract Data for urn:zone:configurations-pilet:configuration-provider:content */

export interface ConfigurationProviderContentContractData {
	/**
	 * Configuration object
	 */
	config?: {};
}
/** Block parameters for urn:block:configurations-pilet:settings-button */

export interface SettingsButtonBlockParams {
	/**
	 * A valid RID of the configuration
	 */
	config: string;
	/**
	 * Context for the setting
	 */
	contextRid: string;
	/**
	 * Title for the settings modal
	 */
	title?: string;
}

export namespace BlockNames {
	export const ConfigurationDisplay =
		'urn:block:configurations-pilet:configuration-display' as const;
	export type ConfigurationDisplay =
		'urn:block:configurations-pilet:configuration-display';
	export const ConfigurationProvider =
		'urn:block:configurations-pilet:configuration-provider' as const;
	export type ConfigurationProvider =
		'urn:block:configurations-pilet:configuration-provider';
	export const SettingsButton = 'urn:block:configurations-pilet:settings-button' as const;
	export type SettingsButton = 'urn:block:configurations-pilet:settings-button';
}

export namespace ZoneTypes {
	export const ConfigurationProviderContent =
		'urn:zone:configurations-pilet:configuration-provider:content' as const;
	export type ConfigurationProviderContent =
		'urn:zone:configurations-pilet:configuration-provider:content';
}

export type ConfigurationDisplayProps = ShellProps &
	BlockParams &
	ConfigurationDisplayBlockParams;
export type ConfigurationProviderProps = ShellProps &
	BlockParams &
	ConfigurationProviderBlockParams;
export type SettingsButtonProps = ShellProps & BlockParams & SettingsButtonBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:block:configurations-pilet:configuration-display']: BlockParams &
			ConfigurationDisplayBlockParams;
		['urn:block:configurations-pilet:configuration-provider']: BlockParams &
			ConfigurationProviderBlockParams;
		['urn:block:configurations-pilet:settings-button']: BlockParams &
			SettingsButtonBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {
		['urn:zone:configurations-pilet:configuration-provider:content']: ConfigurationProviderContentZoneParams;
	}

	interface ViewEngineCustomZoneContractDataMap {
		['urn:zone:configurations-pilet:configuration-provider:content']: ConfigurationProviderContentContractData;
	}
}
